export default {
    '1': 'Verkeerde produk bestel',
    '2': 'Duplikaat bestelling',
    '3': 'Kan nie ontvang nie',
    '4': 'Ander redes',
    '充值金额不能小于1': 'Formaatfout: laaibedrag mag nie minder as 1 wees nie (twee desimale)',
    '-连接已建立-': '-Verbinding gevestig-',
    ',才可提币': ', voordat jy kan onttrek',
    '[code]值错误': '[code] waarde is ongeldig',
    '[symbol]参数为空': '[symbol] parameter is leeg',
    homeDownloadtips41: 'Handelaar-app',
    '不能为空': 'Mag nie leeg wees nie',
    '不在交易时段': 'Buite handelsure',
    '不在可提现时间内': 'Buite onttrekkingstyd',
    '参数错误': 'Parameterfout',
    '参数异常，消息获取失败': 'Parameter abnormaal, kon nie boodskap kry nie',
    '操作成功': 'Bewerking suksesvol',
    '操作类型不能小于0': 'Bewerkingstipe mag nie minder as 0 wees nie',
    '操作类型不是整数': 'Bewerkingstipe is nie \'n heelgetal nie',
    '操作类型为空': 'Bewerkingstipe is leeg',
    '产品不存在': 'Produk bestaan nie',
    '产品剩余数量不足': 'Oorblywende produkhoeveelheid onvoldoende',
    '承兑商不存在': 'Handelaar bestaan nie',
    '程序错误': 'Programfout',
    '持有币种不足': 'Onvoldoende geldeenheidbesit',
    '充值价值不得大于最大限额': 'Laaiwaarde mag nie die maksimum limiet oorskry nie',
    '充值价值不得小于最小限额': 'Laaiwaarde mag nie minder as die minimum limiet wees nie',
    '充值链错误': 'Laaiketting-fout',
    '充值数量不能小于等于0': 'Laaihoeveelheid mag nie minder as of gelyk aan 0 wees nie',
    '存在不同杠杆的持仓单': 'Daar is posisies met verskillende hefboom',
    '存在重复的角色名称': 'Duplikaat rolnaam bestaan',
    '大于最大采购数量': 'Groter as maksimum aankoophoeveelheid',
    '代理层级错误': 'Agentvlak-fout',
    '待付款的订单无法放行': 'Onbetaalde bestelling kan nie vrygestel word nie',
    '当前地址格式错误': 'Huidige adresformaat is ongeldig',
    '当前订单不为待付款状态，无法取消': 'Bestelling is nie in afwagting-van-betaling-status nie, kan nie kanselleer nie',
    '当前还需交易': 'Verdere handel word steeds vereis',
    '当日才可申购': 'Inskrywing slegs op dieselfde dag moontlik',
    '当日可提现次数不足': 'Onvoldoende onttrekkings vir vandag',
    '登陆密码不符合设定': 'Aanmeldwagwoord voldoen nie aan vereistes nie',
    '登陆密码长度不符合设定': 'Lengte van aanmeldwagwoord voldoen nie aan vereistes nie',
    '登录过期，请重新登录': 'Sessie verval, meld asseblief weer aan',
    '登录密码必须6-12位': 'Aanmeldwagwoord moet 6-12 karakters wees',
    '登录密码不能为空': 'Aanmeldwagwoord mag nie leeg wees nie',
    '登录失败': 'Aanmelding het misluk',
    '电话号码已绑定': 'Telefoonnommer reeds gekoppel',
    '电话号码已绑定其他用户': 'Telefoonnommer is reeds aan \'n ander gebruiker gekoppel',
    '订单不存在': 'Bestelling bestaan nie',
    '订单已取消': 'Bestelling gekanselleer',
    '订单已取消，无法放行': 'Bestelling gekanselleer, kan nie vrygestel word nie',
    '订单已完成，无法放行': 'Bestelling voltooi, kan nie vrygestel word nie',
    '发现新版本，请升级到最新版本': 'Nuwe weergawe gevind, dateer asseblief op na die nuutste weergawe',
    '服务器错误': 'Bedienerfout',
    '服务器错误(500)': 'Bedienerfout (500)',
    '该产品未上架': 'Hierdie produk is nie gelys nie',
    '该产品已上市，无法购买': 'Hierdie produk is reeds gelys, kan nie koop nie',
    '该订单已取消': 'Hierdie bestelling is gekanselleer',
    '该广告剩余数量不足': 'Oorblywende hoeveelheid van hierdie advertensie onvoldoende',
    '该基金尚未开放购买': 'Hierdie fonds is nog nie oop vir aankoop nie',
    '该基金尚已封闭': 'Hierdie fonds is reeds gesluit',
    '该邮箱已被订阅': 'Hierdie e-pos is reeds ingeteken',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Formaatfout: laaibedrag mag nie minder as 1 wees nie (twee desimale)',
    '跟单倍数输入错误': 'Verkeerde invoer van kopie-handel-veelvoud',
    '跟单参数输入错误': 'Verkeerde invoer van kopie-handel-parameters',
    '更新提醒': 'Opdatering-herinnering',
    '工作地址不能为空': 'Werkadres mag nie leeg wees nie',
    '购买矿机时间不得低于托管订单剩余时间': 'Aankoopduur van mynmasjien mag nie korter as die oorblywende tyd van die aanbiedingbestelling wees nie',
    '广告不存在': 'Advertensie bestaan nie',
    '广告已下架': 'Advertensie verwyder',
    '基金剩余购买金额不足': 'Oorblywende aankoopbedrag van fonds onvoldoende',
    '家庭地址不能为空': 'Huisadres mag nie leeg wees nie',
    '交易员不存在': 'Handelaar bestaan nie',
    '交易员不能跟随自己': 'Handelaar kan nie self volg nie',
    '交易员跟随人数已满': 'Volgertal van handelaar is vol',
    '交易员未开启带单': 'Handelaar het nie kopie-handel geaktiveer nie',
    '交易员无法跟随另一个交易员': '\'n Handelaar kan nie \'n ander handelaar volg nie',
    '角色被用户关联，不可删除': 'Rol is aan gebruikers gekoppel, kan nie verwyder word nie',
    '角色不存在': 'Rol bestaan nie',
    '金额不在购买区间': 'Bedrag is nie in die aankoopreeks nie',
    '金额错误': 'Bedragfout',
    '旧密码不能为空': 'Ou wagwoord mag nie leeg wees nie',
    '旧密码不正确': 'Ou wagwoord is verkeerd',
    '可平仓合约张数不足': 'Onvoldoende aantal kontrakte om te sluit',
    '矿机不存在': 'Mynmasjien bestaan nie',
    '矿机未解锁，无法购买': 'Mynmasjien nie ontsluit nie, kan nie koop nie',
    '历史基金无法购买': 'Historiese fonds kan nie gekoop word nie',
    '连续输入错误三次，请3分钟后再试': 'Drie keer agtereenvolgens verkeerd ingevoer, probeer asseblief oor 3 minute weer',
    '领取成功': 'Suksesvol ontvang',
    '买入金额需要在区间内': 'Aankoopbedrag moet binne die reeks wees',
    '卖方无法取消该订单': 'Die verkoper kan nie hierdie bestelling kanselleer nie',
    '没有找到用户': 'Geen gebruiker gevind nie',
    verificationCode: 'Verifikasiekode',
    pleaseEnterVerificationCode: 'Voer asseblief die verifikasiekode in',
    pleaseEnterUsername: 'Voer asseblief die gebruikersnaam in',
    username: 'Gebruikersnaam',
    getVerificationCode: 'Kry kode',
    tryAgainLater: 'sekondes om weer te probeer',
    '密码必须6-12位': 'Wagwoord moet 6-12 karakters wees',
    '密码不能为空': 'Wagwoord mag nie leeg wees nie',
    '密码不正确': 'Wagwoord is verkeerd',
    '您当前可分配额度不足': 'Jou huidige toewysbare limiet is onvoldoende',
    '您没有符合条件的收款方式': 'Jy het geen geskikte betaalmetode nie',
    '您已存在订单': 'Jy het reeds \'n bestelling',
    '您已购买过体验矿机,不得重复购买': 'Jy het reeds \'n proef-mynmasjien gekoop en kan nie weer koop nie',
    '亲属地址不能为空': 'Adres van familielid mag nie leeg wees nie',
    '亲属电话不能为空': 'Telefoon van familielid mag nie leeg wees nie',
    '亲属关系不能为空': 'Verwantskap mag nie leeg wees nie',
    '亲属姓名不能为空': 'Naam van familielid mag nie leeg wees nie',
    '请检查网络连接': 'Kontroleer asseblief die netwerkverbinding',
    '请切换其他语言后查看': 'Skakel asseblief na \'n ander taal om te sien',
    '请上传图片': 'Laai asseblief \'n prent op',
    '请稍后再试': 'Probeer asseblief later weer',
    '请稍后重试': 'Probeer asseblief later weer',
    '请输入充值币种': 'Voer asseblief die laai-geldeenheid in',
    '请输入内容': 'Voer asseblief inhoud in',
    '请输入搜索关键字': 'Voer asseblief soeksleutelwoord in',
    '请输入正确的货币数量': 'Voer asseblief die korrekte geldeenheidhoeveelheid in',
    '请输入正确的金额': 'Voer asseblief die korrekte bedrag in',
    '请输入正确的数量': 'Voer asseblief die korrekte hoeveelheid in',
    '请输入正确的质押金额': 'Voer asseblief die korrekte stakingbedrag in',
    '请输入正确的质押天数': 'Voer asseblief die korrekte aantal stakingsdae in',
    '请填写正确的电话号码': 'Vul asseblief die korrekte telefoonnommer in',
    '请填写正确的验证码': 'Vul asseblief die korrekte verifikasiekode in',
    '请填写正确的邮箱地址': 'Vul asseblief die korrekte e-posadres in',
    '请先绑定谷歌验证器': 'Koppel asseblief eers Google Authenticator',
    '请先添加收款方式': 'Voeg asseblief eers \'n betaalmetode by',
    '请先通过高级认证': 'Voltooi asseblief eers gevorderde verifikasie',
    '请选择买卖方式': 'Kies asseblief koop/verkoop-metode',
    '请选择正确的币种': 'Kies asseblief die korrekte geldeenheid',
    '请重新登录': 'Meld asseblief weer aan',
    '渠道未开通': 'Kanaal nie geaktiveer nie',
    '取消': 'Kanselleer',
    '确认': 'Bevestig',
    '申购数量错误': 'Inskrywingshoeveelheid is verkeerd',
    '申请成功': 'Aansoek suksesvol',
    '身份证已实名过!': 'ID is reeds geverifieer!',
    '审核已通过': 'Hersiening geslaag',
    '审核中': 'In hersiening',
    '实名认证未通过，无法进行高级认证': 'Identiteitsverifikasie nie geslaag nie, gevorderde verifikasie nie moontlik nie',
    '收款方输入错误': 'Verkeerde invoer van begunstigde',
    '授权状态未成功': 'Magtigingstatus nie suksesvol nie',
    '赎回状态异常': 'Aflossingstatus abnormaal',
    '所选汇率不存在': 'Gekose wisselkoers bestaan nie',
    '提币数量不能小于等于0': 'Onttrekkingshoeveelheid mag nie minder as of gelyk aan 0 wees nie',
    '提交失败': 'Indiening het misluk',
    '提交失败，当前有未处理订单': 'Indiening het misluk, daar is onverwerkte bestellings',
    '提示': 'Kennisgewing',
    '提现不得大于限额': 'Onttrekking mag nie die limiet oorskry nie',
    '提现不得小于限额': 'Onttrekking mag nie minder as die limiet wees nie',
    '图片不得大于10M': 'Prent mag nie groter as 10 MB wees nie',
    '图片不得大于2M': 'Prent mag nie groter as 2 MB wees nie',
    '图片大小不能超过2M！': 'Prentgrootte mag nie 2 MB oorskry nie!',
    '图片上传失败': 'Prent oplaai het misluk',
    '推荐码不正确': 'Verwysingskode is verkeerd',
    '推荐人无权限推荐': 'Die verwyser het nie toestemming om te verwys nie',
    '推荐商品': 'Aanbevole produkte',
    '委托数量(张)必填': 'Bestelhoeveelheid (kontrakte) word vereis',
    '委托数量(张)不能小于等于0': 'Bestelhoeveelheid (kontrakte) mag nie minder as of gelyk aan 0 wees nie',
    '未绑定谷歌验证器': 'Google Authenticator nie gekoppel nie',
    '未绑定手机号': 'Geen telefoonnommer gekoppel nie',
    '未绑定邮箱': 'Geen e-pos gekoppel nie',
    '未发现授权记录': 'Geen magtigingsrekord gevind nie',
    '未实名认证，是否认证？': 'Nie geverifieer nie. Nou verifieer?',
    '未授权访问': 'Ongemagtigde toegang',
    '未找到符合条件的匹配订单': 'Geen passende bestelling gevind nie',
    '未找到匹配的收益记录': 'Geen passende inkomsterekord gevind nie',
    myComment: 'My resensies',
    myPoint: 'My punte',
    accountInfo: 'Rekeninginligting',
    myBalance: 'My saldo',
    myCoupon: 'My koepons',
    unused: 'Ongebruik',
    used: 'Gebruik',
    expired: 'Verval',
    expires: 'Geldig tot',
    minSpend: 'Vanaf',
    availableBalance: 'Beskikbare saldo',
    personalDeposit: 'Saldo',
    useDepositBalance: 'Gebruik saldo vir afslag',
    depositDeduct: 'Saldo-aftrekking',
    useMaxDeposit: 'Volle aftrekking',
    balanceHistory: 'Saldogeskiedenis',
    recordCount: 'Totaal {count} rekords',
    depositType: 'Transaksietipe',
    balanceAfter: 'Oorblywende saldo',
    depositTypeRecharge: 'Saldo herlaai',
    depositTypeAdjustment: 'Saldo-aanpassing',
    depositTypeOrderPayment: 'Bestelbetaling',
    depositTypeOrderRefunds: 'Bestelterugbetaling',
    depositTypeDistributionCommission: 'Verspreidingskommissie',
    depositTypeDistributionWithdrawal: 'Verspreidingsonttrekking',
    depositTypeOther: 'Ander',
    income: 'Inkomste',
    expense: 'Uitgawe',
    description: 'Beskrywing',
    myFootprint: 'My voetspoor',
    '我的购物车': 'My mandjie',
    '无权限': 'Geen toestemming nie',
    '无效的UID': 'Ongeldige UID',
    '系统参数错误': 'Stelselparameterfout',
    '系统存在相同[系统登录名]！': 'Die stelsel het dieselfde [aanmeldnaam]!',
    '系统错误，请稍后重试': 'Stelselfout, probeer asseblief later weer',
    '下单不能小于最小金额限制': 'Bestelling mag nie minder as die minimum bedrag wees nie',
    '校验IP不合法': 'Verifikasie-IP is ongeldig',
    '新密码不能为空': 'Nuwe wagwoord mag nie leeg wees nie',
    '新密码不一致': 'Nuwe wagwoorde stem nie ooreen nie',
    '新密码确认不能为空': 'Bevestiging van nuwe wagwoord mag nie leeg wees nie',
    '行情获取异常，稍后再试': 'Kon nie markdata kry nie, probeer asseblief later weer',
    '验证类型不能为空': 'Verifikasietipe mag nie leeg wees nie',
    '验证码不能为空': 'Verifikasiekode mag nie leeg wees nie',
    '验证码不正确': 'Verifikasiekode is verkeerd',
    '验证码错误': 'Verifikasiekode-fout',
    '页码不能小于等于0': 'Bladsynommer mag nie minder as of gelyk aan 0 wees nie',
    '页码不是整数': 'Bladsynommer is nie \'n heelgetal nie',
    '已领取': 'Reeds ontvang',
    '用户不存在': 'Gebruiker bestaan nie',
    '用户名必须由数字和英文字母组成': 'Gebruikersnaam moet uit syfers en Latynse letters bestaan',
    '用户名不存在': 'Gebruikersnaam bestaan nie',
    '用户名不符合设定': 'Gebruikersnaam voldoen nie aan vereistes nie',
    '用户名不能为空': 'Gebruikersnaam mag nie leeg wees nie',
    '用户名参数为空': 'Gebruikersnaam-parameter is leeg',
    '用户名重复': 'Gebruikersnaam is gedupliseer',
    '用户剩余数量不足': 'Oorblywende gebruikerhoeveelheid onvoldoende',
    '用户已跟随交易员': 'Gebruiker volg reeds die handelaar',
    '邮箱已绑定': 'E-pos reeds gekoppel',
    '邮箱已绑定其他用户': 'E-pos is reeds aan \'n ander gebruiker gekoppel',
    '余额不足': 'Onvoldoende saldo',
    shop_order_insufficientBalance: 'Rekeningsaldo onvoldoende',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Rekening abnormaal, C3-verifikasie vereis. Kontak asseblief aanlyn kliëntediens.',
    '找不到用户': 'Gebruiker nie gevind nie',
    flashSale: 'Flitsuitverkoping',
    groupBuy: 'Groepaankoop',
    groupBuying: 'Groepaankope',
    couponCenter: 'Koeponsentrum',
    pointMall: 'Punte-winkel',
    liveList: 'Lewendige uitsending',
    endsIn: 'Eindig oor',
    soldOut: 'Verkoop',
    people: 'mense',
    joined: 'Aangesluit',
    startGroup: 'Begin groep',
    getCoupon: 'Kry',
    '直线关系，不能修改推荐': 'Direkte verhouding, verwysing kan nie verander word nie',
    '重复提交': 'Duplikaat indiening',
    '转账币种不能为空': 'Oorplasing-geldeenheid mag nie leeg wees nie',
    '转账数量不能小于等于0': 'Oorplasinghoeveelheid mag nie minder as of gelyk aan 0 wees nie',
    '状态不能小于0': 'Status mag nie minder as 0 wees nie',
    '状态不是整数': 'Status is nie \'n heelgetal nie',
    '资金密码必须6-12位': 'Fondswagwoord moet 6-12 karakters wees',
    '资金密码不符合设定': 'Fondswagwoord voldoen nie aan vereistes nie',
    '资金密码不能为空': 'Fondswagwoord mag nie leeg wees nie',
    '资金密码错误': 'Fondswagwoord-fout',
    '资金密码长度不符合设定': 'Lengte van fondswagwoord voldoen nie aan vereistes nie',
    'UID不能为空': 'UID mag nie leeg wees nie',
    required: 'Hierdie veld is verpligtend',
    nickname: 'Bynaam',
    enterNickname: 'Voer asseblief \'n bynaam in',
    gender: 'Geslag',
    male: 'Manlik',
    female: 'Vroulik',
    secret: 'Geheim',
    birthday: 'Verjaarsdag',
    selectDate: 'Kies datum',
  cancelOrderMap: {
    0: "Ek wil dit nie hê nie.",
    1: "Het die produk misplaas",
    2: "Duplikaat bestelling",
    3: "Ontvangs het misluk",
    4: "Ander redes",
  },
  "获取验证码":'Verkieer code',
  "验证码":'Verkieer code',
  "请输入验证码":'Voer asseblief die verkieer code in',
  "发送": 'Verstuur',
  "已发送，请注意查收":"Hierbys verstuur, kies asseblief u naam en adres",
  "电商批发商场": "Elektroniese groothandelsmark",
  "当前余额": "huidige balaans",
  "备注":  "Opmerkings",
  "请输入完整的支付密码!": "Voer asseblief die volledige betaal wagwoord in!",
  "暂无店铺": "Geen winkel nie",
  "用户未发表评论": "User has not commented",
  "订单": "Orde",
  "下单成功，等待付款": "Bestelling suksesvol geplaas, wag vir betaling",
  "下单成功，付款成功": "Bestelling suksesvol geplaas, betaling geslaag",
  "已发货，正在运输中": "Gestuur, in vervoer",
  "订单已取消，原因:手动发起取消订单": "Die bestelling is gekanselleer. Rede: Kanselleer die bestelling met die hand.",
  "订单已取消，原因:超时自动取消订单": "Bestelling is gekanselleer. Rede: Bestelling sal outomaties gekanselleer word met uitteltyd.",
  "商家已确认，已进入备货状态": "Die handelaar is bevestig en het die voorraadstaat betree.",
  "系统发货成功": "Stelselaflewering het geslaag",
  "订单已签收": "Bestelling ontvang",
  "发起退款申请": "Begin 'n terugbetalingversoek",
  "长时间未付款，系统自动取消订单": "Indien betaling vir 'n lang tyd nie gemaak word nie, sal die stelsel outomaties die bestelling kanselleer.", 
  "退款成功": "Terugbetaling het geslaag",
  "退款失败": "Terugbetaling het misluk",
  "订单退款成功": "Terugbetaling van bestelling het geslaag",
  "订单退款失败": "Terugbetaling van bestelling het misluk",
  "系统默认好评": "Die stelsel is verstek na gunstige resensies",
  "请输入关键字搜索": "Voer asseblief sleutelwoord in om te soek",
  "猜你喜欢": "Raai jy hou daarvan",
  "订单已完成": "Die bestelling is voltooi",
  "热销推荐": "Warm verkoopsaanbeveling",
  "头像选择": "Avatar seleksie",
  "修改头像": "Verander jou avatar",
  subOrder: "Dien bestelling in",
  "mailboxCheck": "Vul asseblief die korrekte e-posadres in",
  "switchLang": "Skakel asseblief oor na 'n ander taal om te sien",
  "myCart": "My inkopiemandjie",
  "notQua": "Die kwalifikasievoorwaardes word nie nagekom nie.",
  "noSmaller": "Die toegediende hoeveelheid kan nie minder wees as",
  "nomax": "Die maksimum aansoekbedrag kan nie oorskry nie",
  "evaluationUploading": "Jy het nog foto's wat oplaai. Probeer asseblief weer later",
  "evaluateInput": "Hersien met prente",
  "moneyOrderStatus": "Bestellingstatus",
  "coinBlock": "Valuta-ooreenkoms",
  "dealing": "In proses",
  "dealSuccess": "Suksesvol",
  "dealFail": "Misluk",
  "payCertificate": "Betalingsertifikaat",
  "handleFee": "Diensfooi",
  "highOpinion": "Goeie resensies",
  "mediumOpinion": "Medium resensie",
  "lowOpinion": "Slegte resensies",
  "hasImage": "Met prentjies",
  "rechargeMethod": "Herlaai-modus",
  "scanAndDown": "Skandeer QR-kode Laai APP af",
  "receivedAddress": "Kwitansie adres",
  "ActualLedger": "Werklike kwitansie",
  "view": "Beskou",
  "withdrawNum": "Kontant onttrekking hoeveelheid",
  "rechargeNum": "Herlaai hoeveelheid",
  "date": "Datum",
  "walletHistory": "Beursie geskiedenis",
  "accountBalance": "Rekening balans",
  "accountReview": "Rekeningoorsig",
  "rated": "Hersien",
  "receiver": "Ontvanger",
  "orderStatus": "Status",
  "orderTime": "Tyd",
  "tax": "Belasting",
  "discount": "Afslag",
  "productInfo": "Produk inligting",
  "paramError": "Parameterfout",
  "orderInfo": "Bestel inligting",
  "rebuy": "Nog 'n bestelling",
  "pleaseCorrectAddress": "Voer asseblief die korrekte kontantonttrekkingadres in",
  "pleaseInputCorrectNumber": "Voer asseblief 'n getal groter as 0 in",
  "vcodePass": "Verifikasie geslaag!",
  "vcodeFail": "Stawing het misluk, probeer asseblief weer",
  "uploading": "Laai tans op...",
  "uploadSuccess": "Opgelaai geslaag",
  "uploadError": "Oplaai het misluk. Probeer asseblief weer",
  "registerSuccess": "Registrasie geslaag",
  "pleaseSetMobileNumber": "Stel asseblief die telefoonnommer",
  "unSelectedProduct": "Jy het nie 'n produk gekies nie",
  "loginSuccess": "Aanmelding geslaag",
  "pleaseSetAreaCode": "Voer landnaam en areakode in om te soek",
  "login": "Teken aan",
  "register": "Registrasie",
  "logout": "Verlaat",
  "noData": "Geen data gevind nie",
  "search": "Soek",
  "historySearch": "Historiese soektog",
  "empty": "Leeg",
  "home": "Tuisblad",
  "favorableRate": "Koers van goeie resensies",
  "classification": "Kategorie",
  "searchTips": "Bronsoektog/produk/verskaffer/bestelling",
  "dailyNewArrival": "Daaglikse nuwe produkte gelys",
  "more": "Meer",
  "recommend": "Aanbeveling",
  "recommendedProducts": "Aanbevole produkte",
  "recommendedStore": "Aanbevole winkels",
  "buyNow": "Koop nou",
  "addCart": "Voeg by inkopiemandjie",
  "complex": "Geïntegreerde",
  "price": "Prys",
  "retailPrice": "Kleinhandel prys",
  "originPrice": "Oorspronklike prys",
  "service": "Kliëntediens",
  "collect": "Gunstelinge",
  "sold": "Verkoopsvolume",
  "pageviews": "Hoeveelheid blaai",
  "quantity": "Hoeveelheid",
  "freight": "Vrag",
  "shipping": "Gestuur",
  "ship": "Boot",
  "buyTips": "Stuur binne 24 uur na die bestelling geplaas. Die volgende bestellings is onder logistieke beheer en kan laat versend word. Gee asseblief aandag aan logistieke inligting of kontak kliëntediens.",
  "totalPrice": "Totale prys",
  "addCartMessage": "Suksesvol by inkopiemandjie gevoeg",
  "addCartMessageFaild": "Die produk bestaan reeds in die inkopiemandjie.",
  "myAccount": "My qccount",
  "buyHistory": "Koop rekords",
  "wishlist": "Gunsteling produkte",
  "trackOrder": "Orde",
  "account": "Rekening:",
  "sellerZone": "Handelaar gebied",
  "beSeller": "Word 'n handelaar",
  "sellerPanelLogin": "Handelaar aanmeld",
  "footTip": "© Kopiereg {name} Bpk 2024",
  "footTips": "{name} Beperk is gemagtig en gereguleer deur die Finansiële Gedragsowerheid as 'n kredietmakelaar (713206) en handel uitsluitlik met die lener Home Retail Group CardServices Limited as {name} Financial Services. {name} Financial Services word deur die Finansiële Gedragsowerheid gemagtig en gereguleer om krediet te verskaf (716148). Home Retail GroupCard Services Limited is geregistreer in die Verenigde Koninkryk (04007072) by Avebury, 489-499 Avebury Boulevard, Milton Keynes, Verenigde Koninkryk. MK9 2NW.",
  "item": "Artikel",
  "checkout": "Plaas 'n bestelling",
  "productDescription": "Produk Beskrywing",
  "userEvaluation": "Gebruiker resensies",
  "AllProducts": "Alle produkte",
  "followers": "Volg",
  "sales": "Verkoopsvolume",
  "visitStore": "Besoek die winkel",
  "authentic": "100% eg",
  "dayReturns7": "7 dae terugkeer",
  "shippingDiscounts": "Vrag afslag",
  "safePayment": "Veilige betaling",
  "followed": "Gevolg",
  "dashboard": "Instrumentepaneel",
  "myOrder": "My bestelling",
  "setUp": "Stel op",
  "successTips": "Suksesvol",
  "copySuccess": "Replikasie het geslaag",
  "balance": "Saldo (USDT)",
  "sort": "Tik",
  "commodity": "Produk",
  "browse": "Verkoopsvolume",
  "recharge": "Herlaai",
  "commodityCollection": "Produkversameling",
  "withdraw": "Kontant onttrekking",
  "defaultAddress": "Verstek adres",
  "addNewAddress": "Voeg nuwe adres by",
  "withdrawRecord": "Kontantonttrekkingsrekord",
  "serialNumber": "Bestelling nommer.",
  "time": "Tyd",
  "amount": "Bedrag",
  "processing": "In proses",
  "fail": "Misluk",
  "blockchainNetwork": "Blockchain netwerk",
  "records": "Rekord",
  "withdrawAddress": "Kontant onttrekking adres",
  "withdrawInputTips": "Voer asseblief die onttrekkingadres in",
  "copy": "Replikasie",
  "enterTips": "Kom asseblief in",
  "actualAccount": "Werklike rekening",
  "handlingFee": "Diensfooi",
  "confirm": "Bevestig ontvangs",
  "previous": "Vorige stap",
  "pleaseEnterAddress": "Voer asseblief die adres in",
  "pleaseEnterQuantity": "Voer asseblief hoeveelheid in",
  "withdrawSuccess": "Bestellings suksesvol ingedien",
  "saveQr": "Stoor QR-kode",
  "pleaseEnterAmount": "Voer asseblief die herlaaibedrag in",
  "expectedArrival": "Verwagte aankoms",
  "currentRate": "Huidige wisselkoers",
  "uploadTips": "Bewys van betaling (Laai skermskoot van betalingbesonderhede op)",
  "clickUpload": "Klik om op te laai",
  "uploadPhoto": "Laai asseblief foto's op",
  "rechargeSuccessful": "Herlaai het geslaag",
  "rechargeTips": "\"Herlaai-aanvraag: \"\"Vul asseblief die werklike oordragbedrag eerlik in. Andersins kan die stelsel nie die goedkeuring slaag nie en die herlaaivordering beïnvloed.\"",
  "rechargeRecord": "Herlaai rekord",
  "all": "Almal",
  "pending": "Om betaal te word",
  "cancelled": "Gekanselleer",
  "delivered": "Om gestuur te word",
  "confirmed": "Bevestig",
  "receipt": "Om ontvang te word",
  "harvested": "Ontvang",
  "comment": "Om hersien te word",
  "refund": "Terugbetaling/na-verkope",
  "cancelOrder": "Kanselleer bestelling",
  "cancelReason": "Rede vir kansellasie",
  "cancelOrderTitle": "Kies asseblief 'n rede vir bestellingkansellasie",
  "returnOrderTitle": "Kies asseblief die rede vir die terugkeer",
  "refundInstructions": "Terugbetalingsinstruksies",
  "returnDetailTips": "Gee asseblief 'n resensie oor die produk",
  "cancel": "Kanselleer bestelling",
  "cancelOrder1": "Produk nie ontvang nie",
  "cancelOrder2": "Hou nie daarvan nie, wil dit nie hê nie",
  "cancelOrder3": "Die verkoper het die verkeerde goedere gestuur",
  "cancelOrder4": "Valse handelsmerk",
  "cancelOrder5": "Minder versending, gemis versending",
  "cancelOrder6": "Produk ontvang is beskadig",
  "cancelOrder7": "Daar is 'n kwaliteit probleem",
  "cancelOrder8": "Onderhandel terugbetaling met die handelaar",
  "cancelOrder9": "Ander redes",
  "cancelOrderSuccess": "Bestelling is suksesvol gekanselleer",
  "returnOrderSuccess": "Dien suksesvol in",
  "orderName": "Naam",
  "orderEmail": "E-pos",
  "orderAddress": "Adres",
  "orderNation": "Land",
  "orderState": "Status",
  "orderCity": "Stad",
  "orderPostCode": "Poskode",
  "orderAmount": "Hoeveelheid",
  "orderPrefix": "Totale bestelling",
  "orderFee": "Belasting",
  "orderSpecification": "Spesifikasie",
  "orderCommodity": "Produk",
  "orderQuantity": "Hoeveelheid",
  "orderUnitprice": "Eenheidsprys",
  "orderFreight": "Vrag",
  "orderTax": "Belasting",
  "orderTotal": "Totaal",
  "PaymentOrder": "Betalingsopdrag",
  "Evaluate": "Resensie",
  "CancelOrder": "Kanselleer bestelling",
  "RemindShip": "Herinnering vir versending",
  "Refund": "Terugbetaling",
  "Submitareview": "Dien resensies in",
  "Information": "Inligting",
  "wrongPassword": "Wagwoordfout meer as 3 keer. Probeer asseblief môre weer.",
  "Operate": "Operasie",
  "Item": "Item(e)",
  "From": "Van",
  "hint": "Wenke",
  "CheckDetails": "Sien besonderhede",
  "Payment": "Betaling",
  "Cancel": "Kanselleer",
  "refundSuccessfully": "Terugbetaling het geslaag",
  "pendingPayment": "Om betaal te word",
  "pay": "Betaling",
  "LoginPassword": "Aanteken wagwoord",
  "sure": "Natuurlik",
  "shippingAddress": "Ontvangs adres",
  "transactionPassword": "Transaksie wagwoord",
  "markDefaultAddress": "Merk as verstekversendingsadres",
  "edit": "Geredigeer deur",
  "delete": "Vee uit",
  "Opt": "Kies",
  "piece": "Stk",
  "orderDetails": "Bestel besonderhede",
  "shopCollection": "Voeg die winkel by gunsteling",
  "addAddress": "Voeg nuwe adres by",
  "signUp": "Registrasie",
  "loginTips": "Reeds 'n rekening?",
  "loginIn": "Teken aan",
  "mobile": "Telefoon nommer",
  '购物车还没有商品': "Die inkopiemandjie het nog nie produkte nie",
  '去购物': "Gaan inkopies doen",
  "modifyAddress": "Wysig adres",
  "desc": "Stel as verstekadres",
  "keep": "Handhaaf",
  "onlineService": "Aanlyn dienste",
  "send": "Stuur",
  "EsShop": "Aanlyn winkel",
  "desc3": "Voer transaksiewagwoord in",
  "desc4": "Voer jou transaksiewagwoord in",
  "desc6": "Voer weer jou transaksiewagwoord in",
  "setUpPayPaw": "Stel transaksiewagwoord in",
  "setSuccess": "Opstelling het geslaag",
  "confirmPayPaw": "Bevestig transaksiewagwoord",
  "paymentSuccessful": "Betaling het geslaag",
  "desc5": "Verkeerde afleweringsadres? Kontak",
  "customeService": "Aanlyn kliëntediens",
  "BackHome": "Terug na tuisblad",
  "Checkorder": "Besigtig bestelling",
  "ForgotPassword": "Die wagwoord vergeet?",
  "signIn": "Teken aan",
  "noAccount": "Geen rekeningnommer nie?",
  "pleaseEnterAccount": "Voer asseblief rekeningnommer in",
  "pleaseEnterPassword": "Voer asseblief wagwoord in",
  "password": "Wagwoord",
  "mobilePhone": "Telefoon nommer",
  "pleaseEnterPhoneNumer": "Stel asseblief die telefoonnommer",
  "setPassword": "Stel wagwoord in",
  "noDataFound": "Geen data gevind nie",
  "searchCountry": "Voer landnaam en areakode in om te soek",
  "pleaseEnterEmail": "Stel asseblief die posbus",
  "invitationCode": "Uitnodigingskode",
  "plaeseEnterInvitaionCode": "Stel asseblief die uitnodigingskode",
  "pleaseSetLoginPassword": "Stel asseblief die aanmeldwagwoord in",
  "selectDeliveryAddress": "Kies afleweringsadres",
  "totalOf": "Totaal",
  "items": "Item",
  "orderSummary": "Bestelling opsomming",
  "paymentMethod": "Betalings metode",
  "Balance": "Balans",
  "payPal": "PayPal",
  "notOpen": "Hierdie betaalmetode is nog nie oop vir jou streek nie",
  "mastercard": "MasterCard",
  "additional": "Ekstra",
  "handlingfee": "Diensfooi word vereis",
  "goodsNumber": "Hoeveelheid produkte",
  "deliveryFee": "Vrag",
  "totalNum": "Totaal",
  "new": "Nuut",
  "oldPassword": "Ou wagwoord",
  "pleaseEnterOldPassword": "Voer asseblief die ou wagwoord in",
  "newPassword": "Nuwe Wagwoord",
  "plaseeEnterNewPassword": "Voer asseblief die nuwe wagwoord in",
  "confirmPassword": "Bevestig Wagwoord",
  "plaseeENterConfirmPassword": "Voer asseblief die bevestigingswagwoord in",
  "twoPawword": "Twee wagwoorde is nie dieselfde nie",
  "rechargeAddress": "Herlaai adres",
  "plaseEnterRechargeAddress": "Voer asseblief die herlaaiadres in",
  "userCenter": "Persoonlike sentrum",
  "merchantSettled": "Handelaarinskrywing",
  "upNew": "Nuwe produk gelys",
  "balanceNot": "Die balans is nie genoeg nie. Herlaai asseblief.",
  "NoProductSelected": "Produk nog nie gekies nie",
  "ShippingAddressNotSet": "Versendingsadres nie gestel nie",
  "consigneeName": "Naam van ontvanger",
  "email": "E-pos:",
  "areaCode": "Internasionale area kode",
  "phoneNumber": "Telefoon nommer",
  "nation": "Land",
  "state": "Provinsie/Staat/Staat",
  "city": "Stad",
  "postCode": "Poskode",
  "address": "Gedetailleerde adres",
  "addAddressOrModifyAddress": "Voeg nuwe adres by/Verander adres",
  "setAsTheDefaultAddress": "Stel as verstekadres",
  "proceed": "Aanhou",
  "btnSure": "Bevestig",
  "pleaseInput": "Kom asseblief in",
  "allProduct": "Alle produkte",
  "myCommodityCollection": "Gunsteling produkte",
  "myFollowedShops": "Volg die winkel",
  "mySold": "Verkoop",
  "myPageviews": "Hoeveelheid blaai",
  "myPraiseRate": "Koers van goeie resensies",
  "myUnfollow": "Ontvolg",
  "inputNum": "Getalle",
  "inpuEmailErro": "Voer asseblief die korrekte e-posadres in",
  "goodsShip": "Versending",
  "goodsShipTips": "Die produkte sal binne 24 uur na die bestelling gestuur word. Indien logistieke beheer vir die volgende bestelling bestaan, kan die bestelling vertraag word. Let asseblief op die logistieke inligting van die bestelling of kontak die kliëntediens.",
  "goodsFreight": "Vrag",
  "goodsFreeShipping": "Verniet",
  "goodsFreightTips1": "1. Oorgrens produkvragsamestelling: vrag=versendingsfooi+ langafstandvrag+ afleweringsfooi",
  "goodsFreightTips2": "2. Indien die posvoorwaardes nie nagekom word nie, sal die vrag volgens die werklike voorwaardes gehef word.",
  "goodsFreightTips3": "3. Die reg op finale uitleg behoort aan die platform.",
  "pleaseValidPostCode": "Voer asseblief meer as 4 syfers in",
  "pleaseValidEmail": "Voer asseblief die korrekte e-posadres in",
  "pleaseValidPhone": "Voer asseblief die korrekte telefoonnommer in",
  "productAvailable": "Hierdie produk is afgeneem",
  "validatorMaxNumber": "Bedrag oorskry die limiet",
  "validatorRequire": "Vereiste items kan nie nul wees nie",
  "validatorPhone": "Voer asseblief die korrekte telefoonnommer in",
  "validatorEmail": "Voer asseblief die korrekte e-posformaat in",
  "validatorPassword": "Die wagwoord bestaan uit 6-12 syfers of letters(bevat spesiale karakters)",
  "validatorSixNumber": "Voer asseblief 6 suiwer syfers in",
  "validatorFourMoreNumber": "Voer asseblief 'n kombinasie van 4-32 syfers of letters in",
  "validatorIpRule": "Verkeerde IP-formaat",
  "validatorChineseAndEnglish": "Slegs Chinees en Engels, voer reeks in: 8-64 karakters",
  "collectionSuccess": "Voeg suksesvol by gunsteling",
  "followedSuccess": "Volg geslaag",
  "cancelSuccess": "Gekanselleer geslaag",
  "evaluateOrder": "Hersien met prente",
  "evaluateOrderPlaceholder": "Hersien asseblief die produkte",
  "operationSuccess": "Operasie het geslaag",
  "confirmReceiveGoods": "Bevestig ontvangs van die produk of nie",
  "evaluateOrderSuccess": "Hersiening het geslaag",
  "yesterday": "Gister",
  "notLogin": "Jy het nog nie aangemeld nie.",
  "delAllHistoryRecord": "Is jy seker jy wil al die geskiedenisrekord uitvee?",
  "or": "Of",
  "tipsRemindsText": "Die handelaar sal 'n aanmaning ontvang nadat die versending herinner is",
  "tipsRemindsCount": "Dit kan net een keer herinner word.",
  "tipsRemindsMerchant": "Herinner handelaars",
  "tipsRemindsSuccess": "Herinnering het geslaag",
  "noCartTips": "Jou inkopiesak is leeg. Begin inkopies doen.",
  "defaultRate": "Die stelsel is verstek na gunstige resensies",
  "prevPage": "Vorige bladsy",
  "nextPage": "Volgende bladsy",
  "returnApply": "Terugbetaling versoek",
  "returnReason": "Rede vir terugbetaling",
  "returnAmount": "Retourbedrag",
  "returnRemark": "Gee instruksies terug",
  order: {
    cancel: "Kanselleer bestelling",
    confirm: "Bevestig ontvangs",
    payment: "Betaal nou",
    remind: "Herinnering vir versending",
    return: "Versoek om produkterugbetaling",
    evaluate: "Hersien nou",
    logistics: "Kyk na logistiek",
    noRefund: "Onterugbetaal",
    refunding: "Terugbetaling aan die gang",
    refundSuccess: "Terugbetaling het geslaag",
    refundFail: "Terugbetaling het misluk",
        expressCompany: 'Koerier',
        trackingNo: 'Nasporingnommer',
        noOrderShipping: 'Geen versendingsinligting',
        noTransitSteps: 'Geen nasporingopdaterings',
        logisticsLoadFail: 'Kon nie logistiek laai nie. Probeer later weer.'
  },
  "remindTitle": "Herinnering vir versending",
  "remindContent": "Nadat die versending herinner is, sal die handelaar die aanmaning ontvang. Dit kan net een keer herinner word.",
  "remindSuccess": "Herinnering het geslaag",
  "remindRepeat": "Hierdie bevel is herinner.",
  "noComments": "Geen resensie tans nie",
  "storeSeach": "Soek vir produk in hierdie winkel",
  "storeSeachTips1": "Vir jou gevind",
  "storeSeachTips2": "Verwante winkels gevind",
  "storeSeachTips3": "Tuis",
  "creditTit": "Kredietdienste",
  "getCoupons": "Kry meer koepons",
  "yourEmail": "Jou eposadres",
  "subscription": "Subskripsies",
  "paymethods": "Betalings metode",
  "footdec": "{name} globale werfgebruikers kom van {num} lande regoor die wêreld en gebruik {coin} vir nedersetting. {coin} is 'n grenslose transaksie wat onmiddellike, laekostetransaksies regoor die wêreld moontlik maak sonder om te wag en internasionale fooie.",
  "custService": "Kliëntediens",
  "helpLine": "Aanlyn kliëntediens",
  "contactUs": "Kontak Ons",
  "partner": "Koöperatiewe verskaffers",
  "buyRules": "Koper reëls",
  "sellerRules": "Verkoper se beleid",
  "returnsAndEx": "Opgawes en ruil",
  "servicePolicy": "Diensbeleid",
  "returnPolicy": "Retourbeleid",
  "user_Center": "Gebruikersentrum",
  "userReg": "Gebruikersregistrasie",
  "orderTrack": "Bestelling navraag",
  "purchageHistory": "Aankoop geskiedenis",
  "myPurse": "My beursie",
  "aboutUs": "Oor ons",
  "Recruitment": "Wag vir talentvolle persone",
  "news": "Nuus inligting",
  "stateMent": "Moderne slawerny verklaring",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "okx",
  "metaMask": "Metamasker",
  "homeBannertips1": "Word 'n handelaar",
  "homeBannertips2": "Totale kommissie",
  "homeBannertips3": "Maks.",
  "homeBannerbtn": "Sluit nou aan",
  "homeDownloadtips1": "Oorgrens e-handel groothandel winkelsentrum",
  "homeDownloadtips2": "Handelsmerk spesiale aanbod",
  "homeDownloadtips3": "Ononderbroke afslag",
  "homeDownloadtips4": "Android aflaai",
  "homeDownloadtips5": "Apple aflaai",
  "homeDownloadtips6": "Skandeer QR-kode om APP af te laai",
  "homeIconTips1": "100% eg",
  "homeIconTips2": "7 dae terugkeer",
  "homeIconTips3": "Vrag afslag",
  "homeIconTips4": "Veilige betaling",
  "headerSearchTips": "Voer asseblief sleutelwoord in om te soek",
  "collAccount": "Leenwyse",
  "mine": "Myne.",
  "creditText1": "Aanvangslenings los die moeilikheid om geld te leen op",
  "creditText2": "Verskaf aanvangslenings- en kapitaalomsetdienste",
  "creditWorry": "Bekommernisvrye lening",
  "creditQuota": "Buigsame limiet",
  "creditQuotaINFO": "100,000 tot 30,000,000 met buigsame limiet en geen beperkings, met 'n maksimum leningstermyn van een jaar.",
  "quickLoan": "Vinnige lening",
  "creditReview": "Slaag die oudit op die vroegste binne een uur, as die hersiening geslaag word, sal die lening dadelik vrygestel word.",
  "safe": "Veilig en sonder kommer",
  "safeInfo": "Geen verband, geen deposito, geen terugbel nie, want dit is eintlik 'n private aangeleentheid.",
  "about": "Oor ons",
  "aboutText1": "\"Ons is daartoe verbind om finansiële dienste te leen, gebaseer op die \"\"kliënt eerste\"\" besigheidsfilosofie, en het die missie om die probleem van kliëntekapitaalomset op te los. Sedert sy stigting het die maatskappy talle kliënte gehelp om die probleem van kapitaalomset op te los.\"",
  "aboutText2": "Limiet: 100 000-30 000 000, buigsame terugbetalingsmetode met lae rente, geen vooraffooi, aanlynlening, geen telefoonoproep vir verifikasie, vertroulike inligting en uitleen op dieselfde dag.",
  "contactUs1": "As jy nie geld by jou vlakmaats wil leen nie, kontak ons asseblief.",
  "committed": "Toegewyd tot entrepreneursleningsdienste",
  "financial": "Gee aandag aan jou finansiële bekommernisse",
  "partnersTit": "Vennoot-aanlyn uitleenplatform",
  "application": "Leningsaansoek",
  "applicant": "Aansoeker",
  "actualName": "Regte naam",
  "yourName": "Voer asseblief die naam in",
  "term": "Leningstermyn",
  "applicationAmount": "Aangevraagde bedrag",
  "rates": "Lening rentekoers",
  "loanMethod": "Leenwyse",
  "accountB": "Rekening balans",
  "countryOf": "Nasionaliteit",
  "myloan": "My lening",
  "applyLoan": "Doen aansoek om 'n lening",
  "loaned": "Geleen",
  "interest": "Rente opgeloop",
  "esRepayment": "Geskatte terugbetaling",
  "loanHistory": "Leningsrekord",
  "applicantDate": "Aansoek datum",
  "repayment": "Terugbetaling",
  "cycle": "Terugbetalingsiklus",
  "fixedRate": "Vaste rentekoers",
  "successLoan": "Lening het geslaag",
  "Reapply": "Doen weer aansoek",
  "borrow": "Lening het misluk",
  "applicantIn": "Aansoek aan die gang",
  "repaid": "Terugbetaling",
  "overdue": "Agterstallig",
  "estirepay": "Geskatte terugbetaling",
  "loanDays": "Aantal dae geleen",
  "reAmount": "Terugbetalingsbedrag",
  "repay": "Terugbetalingsmodus",
  "entRepay": "Bevestig terugbetaling",
  "foryourmoney": "As jy in ’n tekortfonds is, nêrens kry om geld te leen nie of skaam is om geld by jou vriende te leen, kan jy ons kontak. Ons het die hele proses van professionele diens om jou twyfel te eniger tyd te beantwoord. Ons doel is om elke lening deursigtig te maak, sodat kliënte dit vinnig en met selfvertroue kan gebruik.",
  "onlineApplin": "Doen aanlyn aansoek",
  "businessloan": "Aansoek om aanvangslening",
  "selectCountry": "Kies asseblief 'n nasionaliteit",
  "selectPeriod": "Kies asseblief 'n tydperk",
  "passPortImg": "ID No./Paspoort No.",
  "uploadId": "Sertifikaatfoto/paspoort oplaai",
  "readAndAgree": "Ek het gelees en stem saam",
  "loanAgree": "Leningsooreenkoms",
  "submitApplica": "Indiening van aansoek",
  "photoExample": "Voorbeeld van foto's neem",
  "discounted": "Afslag produkte",
  "days": "dag",
  "privacyPolicy": "Privaatheidsbeleid",
  "delivery": "Aflewering en afhaal",
  "checkAgreement": "Merk asseblief die ooreenkoms!",
  "businessPhone": "Besigheidsfoon",
  "businessEmail": "Korporatiewe e-pos",
  "请选择收货地址": "Kies asseblief 'n afleweringadres",
  recommendclass:"Beveel kategorie aan",
  "滑动验证": "Sleep die skuifbalk om te verifieer",
  "最多上传9张图片": "Maksimum 9 foto's kan opgelaai word",
  "账号注销": "Rekeningafslag",
  "确定注销": "Bevestig afslag",
  "您的账号": "Jou rekening",
  "为什么要离开": "Waarom moet jy gaan",
  "职业机会": "loopbaan geleenthede",
  "您还有余额,不能注销账号": "Jy het nog 'n balans, kan nie jou rekening afslaan nie!",
  "请输入注销理由": "Voer asseblief die rede vir afslag in",
  "您确认要注销吗?": "Is jy seker jy wil jou rekening afslaan?",
  "我再考虑下": "Ek is aan die oorweeg",
  "同意注销": "Akkoord met afslag",
  "注销成功": "Afslag suksesvol",
  "cancelInfo":"waarsku! Wees asseblief versigtig om die rekening te kanselleer. As jy nie meer die rekening gebruik nie, kan jy [Agree to Cancellation] klik. Jy sal dalk nie binne 'n paar dae na kansellasie kan registreer nie.",
  "App下载(买家端)": "App aflaai (koper)",
  "App下载(卖家端)": "App aflaai (verkoper)",
  "请选择":"Kies asseblief",
  "提款地址绑定": "Uitbetalingadresbinding",
  "绑定成功": "Binding suksesvol",
  "仅能绑定一个收款地址!": "Slegs een betalingsadres kan gebind word!",
  "加值": "Waarde toevoeg",
  "提领": "Onttrekking",
  "联系商家": "Kontak verkoper",
  "银行卡": "Bankkaart",
  "平台人工发起退款": "Platform handmatige terugbetaling",
  "最多包含10位小数": "Maksimum van 10 desimale",
  "加密货币": "Kriptogeldeenheid",
  "银行卡": "Bankkaart",
  "充值币种": "Oplaai geldeenheid",
  "充值金额": "Oplaai bedrag",
  "充值金额不得小于": "Oplaai bedrag mag nie minder wees nie",
  "充值金额不得大于": "Oplaai bedrag mag nie meer wees nie",
  "请先选择币种": "Kies asseblief eers die geldeenheid",
  "开户行": "Bank",
  "请输入开户行名称": "Voer asseblief die naam van die bank in",
  "银行卡号": "Bankkaartnommer",
  "请输入银行卡号": "Voer asseblief die bankkaartnommer in",
  "点击去支付": "Klik om te betaal",
  "企业电话": "Besigheidsfoon",
  "企业证明": "Korporatiewe sertifikaat",
  '参数缺失': "Parameter ontbreek",
  '充值数量必填': "Oplaai hoeveelheid moet ingevul word",
  footTipTikTok:'BizSpring Mall ©️2024 Kopiereg',
  "客户端下载": "Klieptaap download",
  "提现方式": "Uitbetaling",
  TikTokFoot:"BizSpring is 'n wêreldwye kort-video sosiale platform BizSpring en Asië se grootste groothandel handel maatskappy Alibaba, gestig in samewerking. Dit is 'n wêreldwye e-handelsplatform en het drie self-aangedrewe slim pakhuise in die wêreld, geleë in Toronto, Kanada, Los Angeles, en Chiba, Japan. Die produkte wat in die toepassing te koop is, sluit gewilde produkte van Japan, Suid-Korea, China en ander Asiatiese lande in. Op die oomblik het die totale getal 50 000 oorskry en groei steeds vinnig."
,
  "getCouponSuccess": "Suksesvol ontvang",
  "liveRooms": "Lewendige Kamers",
  "liveStreaming": "Lewendig",
  "notStarted": "Nie Begin Nie",
  "finished": "Geëindig",
  "myPoints": "My Punte",
  "searchGoods": "Soek Produkte",
  "points": "Punte",
  "point": "Punte",
  "stock": "Voorraad",
  "spec": "Spesifikasie",
  "exchangeNow": "Ruil Nou",
  "currentPoint": "My Punte",
  "pointNotEnough": "Onvoldoende punte"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "南非荷兰语(af)",
    "addImageHint": "(Voeg asseblief beelde by)",
    "deleteNode": "Vee uit",
    "topPos": "Bo {n}",
    "col": "Kolom {n}",
    "pos": "Posisie {n}",
    "decoType_container": "Houer",
    "decoType_title": "Titelteks",
    "decoType_richText": "Ryk teks",
    "decoType_notice": "Kennisgewing",
    "decoType_blank": "Spasieerder",
    "decoType_banner": "Karrousel",
    "decoType_imageSingle": "Enkele beeld",
    "decoType_imageMulti": "Meervoudige beelde",
    "decoType_video": "Video",
    "decoType_goodsRecommend": "Aanbevole produkte",
    "decoType_goodsSelection": "Produkkeuse",
    "decoType_seckill": "Blitsverkoping",
    "decoType_groupBuy": "Groepaankoop",
    "decoType_coupon": "Koepon",
    "decoType_searchNav": "Soeknavigasie",
    "decoType_search": "Soekblokkie",
    "decoType_searchBox": "Soekblokkie",
    "decoType_categoryNav": "Kategorienavigasie",
    "decoType_goodsCategory": "Produkkategorie",
    "decoType_navIconRow": "Navigasie-ikone",
    "decoType_imageScroll": "Beeldrol",
    "decoType_pageBanner": "Bladsybanier",
    "decoType_tabs": "Oortjies",
    "decoType_brand": "Handelsmerk",
    "decoType_storeRecommend": "Aanbevole winkels",
    "decoType_hotSelection": "Gewilde keuse",
    "decoType_footerLinkGroup": "Voetskakels",
    "decoType_partnerLogoRow": "Vennote",
    "decoType_icpInfo": "ICP-inligting",
    "decoType_topNavMenu": "Bo-navigasie",
    "decoType_logoBlock": "Logo",
    "decoType_langSwitcher": "Taal",
    "decoType_currencySwitcher": "Geldeenheid",
    "decoType_loginBlock": "Aanmeld",
    "decoType_cartIcon": "Mandjie",
    "decoType_messageIcon": "Boodskappe",
    "seckillPrice": "Blitsprys",
    "seckillTag": "Blitsverkoping",
    "seckillCountdown": "Eindig oor",
    "seckillNotStarted": "Binnekort",
    "seckillRushing": "Aan die gang",
    "seckillWillStart": "Binnekort",
    "seckillBuy": "Koop nou (blits)",
    "groupPrice": "Groepprys",
    "groupRequiredNum": "mense vir groep",
    "noGroupBuy": "Koop alleen",
    "groupRule1": "1. Kies item",
    "groupRule2": "2. Begin groep",
    "groupRule3": "3. Groep voltooi → versending",
    "marketingMoneyOff": "Afslag",
    "marketingFreeShipping": "Gratis versending",
    "marketingGift": "Geskenk",
    "marketingCoupon": "Koepon",
    "marketingGroup": "Groepaankoop",
    "marketingSeckill": "Blitsverkoping",
    "marketingExpired": "Promosie verstreke",
    "marketingNotActive": "Promosie nie aktief nie",
    "alreadyGotCoupon": "Ontvang",
    "couponReceived": "Ontvang",
    "hotSearch": "Gewilde soektog:"
}